import type { OutgoingStatisticsResponse } from '../../../store/reducers/OutgoingStatisticsSlice';

import type { OutgoingStatisticMetrics } from './outgoingStatisticMetrics';
import type { OutgoingStatisticRow } from './statisticRowTypes';
import { createMetricRow } from './statisticRowFactory';

export const ATTEMPT_DISTRIBUTION_SECTION =
  'Распределение результатов по попыткам с целевым результатом';

export const buildAttemptDistributionTaskRows = (
  statistic: OutgoingStatisticsResponse,
  metrics: OutgoingStatisticMetrics,
): OutgoingStatisticRow[] => [
  createMetricRow({
    key: 'attemptDistribution-oneAttemptTargetTasksCount',
    section: ATTEMPT_DISTRIBUTION_SECTION,
    parameter: 'Результат с 1 попытки с целевым результатом',
    value: statistic.oneAttemptBusinessResultTasksCount,
    denominator: metrics.processedTasksCount,
  }),
  createMetricRow({
    key: 'attemptDistribution-twoAttemptTargetTasksCount',
    section: ATTEMPT_DISTRIBUTION_SECTION,
    parameter: 'Результат со 2 попытки с целевым результатом',
    value: statistic.twoAttemptBusinessResultTasksCount,
    denominator: metrics.processedTasksCount,
  }),
  createMetricRow({
    key: 'attemptDistribution-threeAndMoreAttemptTargetTasksCount',
    section: ATTEMPT_DISTRIBUTION_SECTION,
    parameter: 'Результат с 3+ попыток с целевым результатом',
    value: statistic.threeAndMoreAttemptBusinessResultTasksCount,
    denominator: metrics.processedTasksCount,
  }),
  createMetricRow({
    key: 'attemptDistribution-technicalTasksCount',
    section: ATTEMPT_DISTRIBUTION_SECTION,
    parameter: 'Целевой результат не получен (технич.)',
    value: metrics.technicalTasksCount + metrics.noAttemptTasksCount,
    denominator: metrics.processedTasksCount,
  }),
];

export const buildAttemptDistributionCallRows = (
  statistic: OutgoingStatisticsResponse,
  metrics: OutgoingStatisticMetrics,
): OutgoingStatisticRow[] => [
  createMetricRow({
    key: 'attemptDistribution-oneAttemptTasksAttemptCount',
    section: ATTEMPT_DISTRIBUTION_SECTION,
    parameter: 'Звонки в заданиях с целевым результатом за 1 попытку',
    value: metrics.oneAttemptBusinessResultTasksAttemptCount,
    denominator: metrics.processedTasksAttemptCount,
  }),
  createMetricRow({
    key: 'attemptDistribution-twoAttemptTasksAttemptCount',
    section: ATTEMPT_DISTRIBUTION_SECTION,
    parameter: 'Звонки в заданиях с целевым результатом за 2 попытки',
    value: metrics.twoAttemptBusinessResultTasksAttemptCount,
    denominator: metrics.processedTasksAttemptCount,
  }),
  createMetricRow({
    key: 'attemptDistribution-threeAndMoreAttemptTasksAttemptCount',
    section: ATTEMPT_DISTRIBUTION_SECTION,
    parameter: 'Звонки в заданиях с целевым результатом за 3+ попытки',
    value: statistic.threeAndMoreAttemptBusinessResultTasksAttemptCount,
    denominator: metrics.processedTasksAttemptCount,
  }),
  createMetricRow({
    key: 'attemptDistribution-negativeTasksAttemptCount',
    section: ATTEMPT_DISTRIBUTION_SECTION,
    parameter: 'Звонки в заданиях без целевого результата (технич.)',
    value: metrics.technicalTasksAttemptCount,
    denominator: metrics.processedTasksAttemptCount,
  }),
];
